var map = {
	"./": 163,
	"./cardapioSaurus/logos/icon.png": 486,
	"./cardapioSaurus/logos/logo.png": 487,
	"./file-exporter": 230,
	"./file-exporter.ts": 230,
	"./global/imagens/bg.png": 134,
	"./global/imagens/loading.gif": 488,
	"./global/imagens/ola.png": 313,
	"./global/imagens/sacolaVazia.svg": 314,
	"./global/imagens/semFoto.png": 176,
	"./global/imagens/triste.png": 217,
	"./index": 163,
	"./index.ts": 163,
	"./menuVip/logos/icon.png": 489,
	"./menuVip/logos/logo.png": 490,
	"./menuVip/logos/logo2.png": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;